export default {
  scorecard: {
    title: 'Fiche de notation',
    content: 'Contenu',
    award: 'Prix ESG',
  },
  list_table_filter: {
    table_buyer_company_name: 'Acheteur',
    table_question_group_name: 'Enquête',
    table_status: 'Statut',
    table_issue_at: "Date d'émission",
    table_sustaina_rate: 'Note ESG',
    table_esg_score: 'Score ESG',
    table_operation: 'Opération',
    displayed_items_number: 'Afficher {start} à {end} sur {total} entreprises',
    displayed_items_number_empty: 'Afficher 0 sur 0 entreprises',
    no_data_display: 'Les données sont pas pu être trouvée',
    csv_modal_title: 'Veuillez sélectionner les éléments à exporter au format CSV',
    csv_modal_answer_status_title: 'Statut de la réponse',
    csv_modal_answer_status_text: 'Exporter la liste des statuts des réponses des fournisseurs.',
    csv_modal_answer_title: 'Réponse (1 fichier pour 500 entreprises)',
    csv_modal_answer_title_by_individual_company: 'Réponse (1fichier par entreprise)',
    csv_modal_answer_text: 'Les réponses des fournisseurs seront éditées dans 1 fichier par 500 entreprises.',
    csv_modal_answer_text_by_individual_company: 'Les réponses des fournisseurs seront éditées dans 1 fichier par 1 entreprise.',
    csv_modal_score_title: 'Score',
    csv_modal_score_text: 'Exporter les évaluations et les notes des fournisseurs.',
    csv_modal_answer_heading: 'En-tête',
    csv_modal_answer_heading_supplier: 'Fournisseur',
    csv_modal_answer_heading_question: 'Question',
    csv_modal_answer_additional: 'Élément supplémentaire',
    csv_modal_answer_additional_note: 'Remarques',
    csv_modal_answer_additional_file: 'Nom du fichier joint',
    csv_modal_cautionary_note_title: 'Notification',
    csv_modal_cautionary_note_content: "・Le fichier de sortie comprend « statut de la réponse », « réponse » et « score » pour {questionGroupName}.\n・Pour le « statut de la réponse », toutes les entreprises enregistrées sont incluses, quel que soit leur statut de réponse à l'enquête.\n・Pour « réponse » et « score », les entreprises dont le statut de réponse est « En cours » ne sont pas incluses dans le fichier de sortie.\n・Le nombre maximum d'entreprises pouvant être affichées dans un seul fichier CSV pour « réponse » et « score » est de 1000.\n・Le fichier CSV sera envoyé à l'adresse e-mail du compte actuellement connecté.",
    csv_modal_sent_mail_section_one: "Votre demande d'exportation CSV a été acceptée.",
    csv_modal_sent_mail_section_two: "Veuillez patienter un moment jusqu'à ce qu'un e-mail contenant l'URL pour télécharger le CSV soit envoyé à votre adresse e-mail.",
    csv_modal_sent_mail_section_three: "Si vous ne recevez pas d'e-mail dans les 30 minutes, veuillez réessayer.",
  },
  overall_score_section: {
    card_title: "Contenu de l'enquête",
    score: 'Score',
    esg_score: 'Score ESG',
    esg_rating: 'Note ESG',
    esg_score_tip: 'Le score ESG est une évaluation des activités ESG de votre entreprise.Il est calculé sur la base de vos réponses au questionnaire ASUENE ESG.',
    esg_rating_tip: 'La notation ESG est une évaluation absolue du niveau des activités ESG de votre entreprise, classée sur une échelle de sept points allant de AAA à CCC, en fonction de votre score ESG.',
    evaluator_advice_title: "Commentaire sur l'évaluation",
    list_header_buyer_company_name: 'Acheteur',
    list_header_supplier_company_name: 'Fournisseur',
    list_header_question: 'Enquête',
    list_header_create_at: "Date d'émission",
    list_header_deadline: "Date d'expiration",
    list_header_industry: "Secteur d'activité",
    list_header_company_scale: "Nombre d'employés",
    list_header_status: 'Statut',
    download_csv: 'Export CSV',
    download_pdf: 'Export PDF',
    // csv_title_for_buyer: "",
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'Télécharger les réponses en csv.',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'Télécharger les réponses en pdf.',
    scorecard_pdf: 'Fiche de notation(PDF)',
    download_scorecard_pdf_description: 'Télécharger le score en pdf.',
    feedback: "Informations sur l'évaluation",
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'Le document sera téléchargé en PDF.',
    award_medal_svg: 'Prix ESG(SVG)',
    download_award_medal_svg_description: 'Télécharger comme image SVG',
    award_medal_png: 'Prix ESG(PNG)',
    download_award_medal_png_description: 'Télécharger comme image PNG',
    pdf_modal_sent_mail_section_one: "Votre demande d'exportation PDF a été acceptée.",
    pdf_modal_sent_mail_section_two: "Veuillez patienter un moment jusqu'à ce qu'un e-mail contenant l'URL pour télécharger le PDF soit envoyé à votre adresse e-mail.",
    pdf_modal_sent_mail_section_three: "Si vous ne recevez pas d'e-mail dans les 30 minutes, veuillez réessayer.",
  },
  category_score_section: {
    card_title: 'Score par catégorie',
    tip: "Un score par catégorie est un score pour la catégorie environnementale, sociale et de gouvernance de votre entreprise. La pondération des questions dans chaque catégorie varie d'une entreprise à l'autre.",
    policy: 'Politique',
    action: 'Action',
    result: 'Résultat',
  },
  score_by_category_compared_section: {
    card_title: 'Comparer les scores par catégorie',
    get_score_by_category: 'Score de votre entreprise par catégorie',
    esg_evaluated_all_companies_average: 'Toutes les entreprises évaluées par Asene ESG',
    tip: "Il s'agit du score moyen des entreprises ayant répondu à la même enquête.",
  },
  strengths_advice_section: {
    card_title: 'Forces et domaines d’amélioration',
    strong_point: 'Force',
    advice: "domaine d'amélioration",
    policies: 'Politique',
    action: 'Action',
    result: 'Résultat',
    no_results_for_this_category: "Il n'y a pas de résultats pour Catégorie.",
    risk: 'Risque',
    indicator: 'Indicateur',
    content: 'Contenu',
    operation: 'Opération',
  },
  preview: {
    go_back_to_scorecard: 'Retourner à la fiche de notation',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: 'Résumé du score global',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: 'Score moyen : ',
    category_card_score_no_score: 'Non applicable',
    category_card_score_earned_score: 'Votre score',
    category_card_details_list_title: "Commentaire sur l'évaluation",
    category_card_details_no_score_tip: "Cette catégorie n'est pas incluse dans l'évaluation.",
    category_card_score_average_score: 'Note moyenne de toutes les entreprises',
    category_card_details_title: 'Résumé du score par catégorie',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: "Cet élément n'est pas applicable, car l'enquête est évaluée selon la logique de l'acheteur.",
    buyer_evaluate_tip: "Cet élément est évalué selon la logique de l'acheteur. Il n'est pas évalué selon la logique de notation d'Asuene ESG.",
    answer_rejection_notification: 'Vous avez reçu une nouvelle demande de retrait',
    answer_rejection_modal_title: 'Renvoyer la demande',
    answer_rejection_modal_text: 'Renvoyer le commentaire',
    answer_rejection_modal_content: 'La réponse de {companyName} sera renvoyée. \nVeuillez écrire un commentaire sur la raison du renvoi',
    answer_rejection_dialog_content: 'La réponse de {companyName} a été renvoyée',
    answer_rejection_button_title: 'Renvoyer',
  },
}
